import { type HospitalData, ShiftType } from "../../../utils/models";

export const isWeekendShift = (shiftType: ShiftType, dayIndex: number): boolean => {
	return (
		(shiftType === ShiftType.Day && (dayIndex === 6 || dayIndex === 0)) ||
		(shiftType === ShiftType.Night && (dayIndex === 5 || dayIndex === 6 || dayIndex === 0))
	);
};

export function getWeekendOnlyNurses(hospitalData: HospitalData): Set<number> {
	const weekendOnlyNurses = new Set<number>(hospitalData.nurses.map((n) => n.id));
	for (const week of hospitalData.weeks) {
		for (const shift of week.weeklyShifts) {
			for (let i = 0; i < shift.days.length; i++) {
				if (!isWeekendShift(shift.type as ShiftType, i)) {
					for (const nurse of shift.days[i].nurses) {
						weekendOnlyNurses.delete(nurse.nurseId);
					}
				}
			}
		}
	}
	return weekendOnlyNurses;
}
